import * as React from 'react';
import {
  PageContainerRow,
  PageContainerCol,
} from 'components/UserManagement/Profile/UserProfileTabbed/UserPrfileTab.Style';
import { Row, Col } from 'antd';
import cartAnimationGif from '../../../assets/images/shopping.gif';
import paymentSpinnerGif from '../../../assets/images/paymentSpinner.gif';
import { PaymentText } from './PaymentProcesingView.Styled';
import { withRouter, RouteComponentProps } from 'react-router';
import { CheckoutHandler } from '../CheckoutForm/CheckoutHandler';
import {
  ExecuteBillOfLadingPaymentRequest,
  CreditCardPaymentMethodDto,
  BeginBillPaymentRequest
} from 'Core/Api/Payment/Api';
import { PaymentProcessingModel } from './PaymentProcessingModel';
import { callbackify } from 'util';
import { Prompt } from 'react-router-dom';
export interface Props extends RouteComponentProps {
  children?: React.ReactNode;
}

export interface State {
  locationListenCallback?: Function;
  canNavigate?: boolean;
  requestState?: any;
}

class PaymentProcessingViewWithoutRouter extends React.Component<Props, State> {
  checkoutHandler: CheckoutHandler;
  constructor(props: Props) {
    super(props);

    this.state = {};
    this.checkoutHandler = new CheckoutHandler(props);
    this.ExecutePayment = this.ExecutePayment.bind(this);
  }

  componentDidMount() {
    console.log("in did mount");
    const callback = this.props.history.listen((location, action) => {
      console.log("in listener");
      if (action != "REPLACE") {
        console.log("Will block navigation");
        this.props.history.block();
      }
    });
    this.setState({ locationListenCallback: callback });

    this.ExecutePayment();

  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.requestState != this.state.requestState) {
      this.props.history.replace('/3d-secure', this.state.requestState);
    }
  }

  componentWillUnmount() {
    this.state.locationListenCallback?.call(this);
  }

  ExecutePayment(hasTriedAlready: boolean = false) {
    const request = this.props.location.state as BeginBillPaymentRequest;
    this.checkoutHandler
      .makePayment(request)
      .then(response => {

        if (response.success) {

          // Payment may comeback as successful but if the APM receipt is not 
          // apart of the message then it should be considered a failure
          this.setState({ canNavigate: true, requestState: response });

        } else {
          this.setState({ canNavigate: true, }, () => {
            this.props.history.replace('/payment-error', response);

          });
        }
      })
      .catch((reason) => {
        const status = reason?.response?.status ?? 500;
        if ((status == 401 || status == 403) && !hasTriedAlready) {
          // Going to make the call again because the call was unathenticated
          // and only failed because the token sometimes isn't passed or it is 
          // and the authentiction service reject it for no reason
          // Should only be possible to try it twice
          console.log("Trying payment again", reason);
          this.ExecutePayment(true);

        }
        this.setState({ canNavigate: true, }, () => {
          this.props.history.replace('/payment-error', reason?.response?.data);
        });
      });
  }

  notReplaceAction = () => {
    return this.props.history.action != "REPLACE";
  }

  render() {
    return (
      <PageContainerRow>
        <Prompt when={!this.state.canNavigate} message="Please click cancel or the transaction may fail" />
        <PageContainerCol>
          <Row type="flex" justify="center">
            <Col span={24}>
              <Row>
                <Col>
                  <img src={cartAnimationGif} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <PaymentText>Processing Payment</PaymentText>
                </Col>
              </Row>
              <Row>
                <Col>
                  <img src={paymentSpinnerGif} />
                </Col>
              </Row>
            </Col>
          </Row>
        </PageContainerCol>
      </PageContainerRow>
    );
  }
}

const PaymentProcessingView = withRouter(PaymentProcessingViewWithoutRouter);
export default PaymentProcessingView;
